export default "__VITE_ASSET__Dv8ijJf9__"